import React from 'react';
import ReactDOM from 'react-dom';
import App from './Application';
import 'semantic-ui-css/semantic.min.css';
import { QueryClient, QueryClientProvider, QueryCache } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { toast } from 'react-toastify';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msal';

const queryClient = new QueryClient({
  // defaultOptions: {
  //   queries: {
  //     staleTime: 5 * 60 * 1000
  //   }
  // },
  queryCache: new QueryCache({
    onError: (error: any, query: any) => {
      // 🎉 only show error toasts if we already have data in the cache
      // which indicates a failed background update
      if (query.state.data !== undefined) {
        toast.error(`Something went wrong: ${error.message}`);
      }
    }
  })
});

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      </QueryClientProvider>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('app')
);